import React from 'react'
import Loadable from 'react-loadable'

import LoginHigherOrder from '../common/loginComponent'
import LoadingComponent from '../common/loadingComponent'


const MultiDimsIndicatorsComponent = Loadable({
  loader: () => import(/*webpackChunkName: '_ch_indicators_multi'*/'./dashboard'),
  loading: () => <LoadingComponent />
});

const Dashboard = (props) => {
  return (
    <MultiDimsIndicatorsComponent
      withTotalTable={props.withTotalTable}
    />
  )
}

export default LoginHigherOrder(Dashboard)